import React from 'react';
import Box from '@mui/material/Box';
import { Toast, ToastProps } from './toast';

interface ToastContainerProps {
  toasts: ToastProps[];
  onClose: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((toast) => (
        <Box key={toast.id} sx={{ pointerEvents: 'auto' }}>
          <Toast {...toast} onClose={onClose} />
        </Box>
      ))}
    </Box>
  );
};
